const params = new URLSearchParams(window.location.search);
const nameLabelQuery = params.get('clientname');

document.querySelectorAll(".nameLabel").forEach(element => {
  element.innerHTML = nameLabelQuery;
});
